import React, { useState, useEffect } from 'react'
import { Panel, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanelWidget from '../ButtonPanelWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import SaveLawListForm from './SaveLawListForm'
import moment from 'moment'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import { getLitigationFile, saveLawLists } from '../../redux/actions/legal'
import notification from '../../utils/notification'
import { SAVE_ERR_MSG } from '../../constants/msgText'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import { getDownload } from '../../redux/actions/lawDocumentform'

export default function SaveLawListWidget(props) {
  const history = useHistory()

  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [errorMsg, setErrorMsg] = useState()
  const [clearValue, setClearValue] = useState(false)

  const onSubmit = (data) => {
    console.log('data : ', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('Files', element.blobFile)
      })

    formData.append('Id', formSchema?.form?.id || '')
    formData.append('LawType', data.lawType || '')
    formData.append('ProjectCode', data.projectCode || formSchema?.form?.projectCode?.value || '')
    formData.append('LitigationName', data.litigationName || '')
    formData.append('DocNumberOfPurchase', data.docNumberOfPurchase || '')
    formData.append('ReferCodeDocument', data.referCode || '')
    formData.append('ReferDateDocument', moment(data.referDateDocument).format('YYYY/MM/DD') || '')
    formData.append('CauseOfWrongdoing', data.causeOfWrongdoing || '')
    formData.append('Note', data.note || '')
    formData.append('Offender', data.offender || '')
    //formData.append('Caretaker', '')
    formData.append('Damages', data.damages || '')
    formData.append('Capital', data.capital || '')
    formData.append('Limitation', moment(data.limitation).format('YYYY/MM/DD') || '')

    data.lawStatus && formData.append('LawStatus', data.lawStatus)
    data.lawSubStatus && formData.append('LawStatus', data.lawSubStatus)

    formData.append('DeleteFileIds', data.deleteFileIds || [])

    handleSaveLegalManagement(formData)
  }

  const handleSaveLegalManagement = async (formData) => {
    startLoading()
    setIsLoading(true)
    setIsError()

    try {
      const response = await saveLawLists(formData)
      if (response) {
        // setFormSchema(response)

        notification.open('success', {
          title: 'บันทึกสำเร็จ',
          duration: 10000,
        })

        setTimeout(() => {
          sessionStorage.setItem('projectId', 'menu')
          history.push({
            pathname: `${pathname.law.ManageLegal}`,
            // pathname: `${pathname.law.ManageLegal}/menu`,
          })
        }, 1000)
      } else {
        setIsError(true)
        setErrorMsg(SAVE_ERR_MSG)
      }
    } catch (error) {
      console.error(error)
      // setIsError(true)
      setErrorMsg(SAVE_ERR_MSG)
    }

    setIsLoading(false)
    doneLoading()
  }

  const onCancel = () => {
    sessionStorage.setItem('projectId', 'menu')

    history.push({
      pathname: `${pathname.law.ManageLegal}`,
      // pathname: `${pathname.law.ManageLegal}/menu`,
    })
    // window.location.href = pathname.law.ManageLegal + '/menu'
    // window.opener = null
  }

  const onDownload = async (fileObj) => {
    startLoading()
    var file = await getLitigationFile(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    var file = await getLitigationFile(fileObj.id)
    const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
    const link = document.createElement('a')
    link.href = url
    link.target = '_blank'
    link.setAttribute('value', fileObj.name)
    document.body.appendChild(link)
    link.click()
    doneLoading()
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={formSchema.header} bordered>
        {formSchema?.form && (
          <SaveLawListForm
            schema={formSchema.form}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            clearErrors={clearErrors}
            clearValue={clearValue}
            //onDelete={onDelete}
            onDownload={onDownload}
            onPreview={onPreview}
          />
        )}

        {isLoading && !isError && <OverlayLoader />}

        <hr />

        {errorMsg && (
          <Message showIcon type={'error'} description={errorMsg} style={{ marginBottom: 20 }} />
        )}

        {formSchema?.form?.buttonText && (
          <ButtonPanelWidget
            isEdit={true}
            // errorMsg={SAVE_ERR_MSG}
            // isError={isError}
            isDisabled={formSchema.form.disabled}
            buttonText={formSchema.form.buttonText}
            onSave={handleSubmit(onSubmit)}
            onCancel={onCancel}
          />
        )}
      </Panel>
    </>
  )
}
